import { connect } from 'react-redux';
import { components } from '@peachjar/components';

import SetupStaffContainer from './containers/SetupStaffContainer';

import {
  setUploading,
  setUploadCSV,
  sendCSV,
  setUploadComplete,
  setFilename,
  setInstructionsViewed,
  setShowTable,
  setUploadPercentage,
  sendValidatedStaffList,
  setTemplateDownloaded,
  setStaffTabView,
  uploadCSV,
  sendStaffEmail,
  toggleStaffEmailSent,
  toggleStaffSendDisable,
} from './setup-staff.duck';

const {
  Notifications: { notifySuccess },
} = components;
const SUCCESS_MESSAGE = 'Your email is on its way!';

const mapDispatchToProps = (dispatch): ReduxDispatchProps => ({
  handleFileUpload: fileList => {
    dispatch(setUploadCSV(fileList));
    dispatch(setFilename(fileList.name));
    dispatch(sendCSV());
    dispatch(setUploadComplete(true));
  },
  handleInstructionsDownload: () => {
    dispatch(setInstructionsViewed(true));
  },
  handleCsvTemplateDownload: () => {
    dispatch(setTemplateDownloaded(true));
  },
  resetFileUpload: () => {
    dispatch(setUploadCSV({}));
    dispatch(setFilename(''));
    dispatch(setUploadPercentage(0));
  },
  setShowTable: () => {
    dispatch(setShowTable(true));
  },
  hideTable: () => {
    dispatch(setShowTable(false));
  },
  setUploadingPercentage: value => {
    dispatch(setUploadPercentage(value));
  },
  sendCSVContents: () => {
    dispatch(sendValidatedStaffList());
  },
  handleStaffEmailSubmit: () => {
    dispatch(sendStaffEmail());
    dispatch(notifySuccess(SUCCESS_MESSAGE)); // TODO: Move dispatching notifySuccess to sendStaffEmail Saga after response is successful
    dispatch(toggleStaffSendDisable(true));
    dispatch(toggleStaffEmailSent(true));
  },
  setStaffTabView: tabView => {
    dispatch(setStaffTabView(tabView));
  },
});

const mapStateToProps = (state): ReduxStateProps => ({
  showTable: state.setupStaff.showTable,
  instructionsViewed: state.setupStaff.instructionsViewed,
  templateDownloaded: state.setupStaff.templateDownloaded,
  uploading: state.setupStaff.uploading,
  uploadComplete: state.setupStaff.uploadComplete,
  uploadPercentage: state.setupStaff.uploadPercentage,
  filename: state.setupStaff.filename,
  order: state.setupStaff.order,
  orderBy: state.setupStaff.orderBy,
  data: state.setupStaff.staffListData,
  errors: state.setupStaff.validationResults,
  staffSendDisable: state.setupStaff.staffSendDisable,
  staffEmailSent: state.setupStaff.staffEmailSent,
  staffTabView: state.setupStaff.staffTabView,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetupStaffContainer);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/index.js